import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManipulationGridComponent } from './manipulation-grid.component';
import {ArmTableModule} from '../arm-table/arm-table.module';

@NgModule({
  declarations: [ManipulationGridComponent],
  exports: [
    ManipulationGridComponent
  ],
  imports: [
    CommonModule,
    ArmTableModule
  ]
})
export class ManipulationGridModule { }
